/**
 * How the enrollment QR is drawn. Shared by both places one is rendered (`EnableMfaDialog` and the
 * inline first-login enrollment in `MfaChallengeForm`) so the two cannot drift.
 */

/**
 * The light border ISO/IEC 18004 requires around a QR symbol, in modules. Scanners use it to locate the
 * finder patterns, and `qrcode.react` draws none by default (`DEFAULT_MARGIN_SIZE = 0`).
 *
 * Without it the symbol only scanned because whatever sat behind it happened to be light: fine on the
 * light theme, which supplied a quiet zone by accident, and unreadable on the dark one, where the code
 * met dark pixels at its own edge. Strict scanners — several Android authenticator apps — failed there
 * while lenient ones (iOS Camera, Google Lens) coped, so it looked like a per-device problem.
 */
export const QR_QUIET_ZONE_MODULES = 4;

/**
 * Pinned rather than left to the library defaults, which already match these. A QR must be dark-on-light
 * to scan, so these two must never become theme-aware: inheriting a dark palette would invert the symbol
 * and break scanning everywhere, in a way that looks like a styling change rather than a broken enrollment.
 */
export const QR_BACKGROUND = '#FFFFFF';
export const QR_FOREGROUND = '#000000';
